import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import infoIcon from '../assets/images/info-icon.svg'

export const LABEL_TYPE = {
  DANGER: 'danger',
  INFO: 'info',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  WARNING: 'warning',
}

const Container = styled.div`
  display: flex;
  gap: 8px;
  ${props =>
    props.type === LABEL_TYPE.DANGER
      ? `
      color: #a92756;
      `
      : props.type === LABEL_TYPE.WARNING
      ? `
      color: #be6f00;
      `
      : props.type === LABEL_TYPE.INFO
      ? `
      color: #0061d2;
      `
      : props.type === LABEL_TYPE.SUCCESS
      ? `
      color: #0d7a4c;`
      : props.type === LABEL_TYPE.SECONDARY
      ? `
      color: #414346;`
      : ``}
`

const Text = styled.span`
  :before {
    content: '•';
    font-size: 150%;
    margin-right: 8px;
  }

  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`

const Label = ({ type, tooltip, children }) => (
  <Container type={type || LABEL_TYPE.SUCCESS}>
    <Text>{children}</Text>
    {tooltip?.id && tooltip?.content && (
      <>
        <img src={infoIcon} alt="Info icon" data-tip="" data-for={tooltip?.id} />
        <ReactTooltip id={tooltip.id} getContent={() => tooltip.content} />
      </>
    )}
  </Container>
)

Label.propTypes = {
  type: PropTypes.oneOf([LABEL_TYPE.INFO, LABEL_TYPE.SUCCESS, LABEL_TYPE.WARNING]),
  tooltip: PropTypes.object,
  children: PropTypes.node,
}

export default Label
